
import Vue from 'vue';


import BaseForm from '../base-components/BaseForm';
// var teamlist =  require('./teamlist.js');
// Vue.component('team-list', teamlist.default);
import TeamList from './teamlist.js';
Vue.component('team-list', TeamList);
